// extracted by mini-css-extract-plugin
export default {"reportTagsLocationInfo":"styles_reportTagsLocationInfo__3y9ph","bottomBorder":"styles_bottomBorder__qjkpM"};